// Simple jump navigation. To handle fades and fixed positioning
// combine this with the PinnedNav module on the inner DOM element

import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'

gsap.registerPlugin(ScrollToPlugin)
export default class ScrollTo {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.links = this.el.querySelectorAll('[data-scrollto]')
  }

  init() {
    this.links.forEach((item) =>
      item.addEventListener('click', this.handleClick))
  }

  handleClick = (e) => {
    e.preventDefault()
    const link = e.target.parentNode
    let target = link.dataset.scrollto
    if (target) {
      target = `#${target}`
      gsap.to(window, { duration: 1, scrollTo: target, offsetY: 50 })
    }
  }
}
